import { render, staticRenderFns } from "./categoryMatching.html?vue&type=template&id=61d862a4&scoped=true&"
import script from "./CategoryMatching.vue?vue&type=script&lang=js&"
export * from "./CategoryMatching.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMatching.vue?vue&type=style&index=0&id=61d862a4&scoped=true&lang=css&"
import style1 from "./CategoryMatching.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d862a4",
  null
  
)

export default component.exports